import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../components/dataGrid/columnHelpers";
import { formatCurrency } from "../../../utils/mathUtils";

export const useGetColumnsLiquidacionesPendientes = () => {
    const columns = useMemo(() => {
        const baseColumns = [
            {
                field: 'id',
                headerName: 'ID',
                flex: 2
            },
            {
                field: 'nombre',
                headerName: 'Nombre',
                flex: 5
            },
            {
                field: 'apellido',
                headerName: 'Apellido',
                flex: 5
            },
        ];

        return generateColumnsDefaultConfiguration(baseColumns);
    }, []);

    return columns;
}